import script from "./ScriptPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ScriptPanel.vue?vue&type=script&setup=true&lang=js"

import "./ScriptPanel.vue?vue&type=style&index=0&id=366d3c42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-366d3c42"]])

export default __exports__